import { getNewId } from "../formulaBuilderHelpers"

export function getMatrixRowLabelFormikName(
  parentFormikObjectName,
  questionLabelIndex
) {
  return `${parentFormikObjectName}.questionLabels[${questionLabelIndex}].scoreFormula`
}

export function applyNewFormulas(oldFormulas, newFormulas) {
  let newSet = [
    ...oldFormulas.map((oldFormulasEntry) =>
      markFormulaEntryAsDeleted(oldFormulasEntry)
    ),
    ...newFormulas.map((newFormulasEntry) =>
      markFormulaEntryAsNew(newFormulasEntry)
    ),
  ]

  return newSet
}

function markFormulaEntryAsNew(formulaEntry) {
  formulaEntry.isNew = true
  formulaEntry.id = getNewId("FORMULA")

  if (formulaEntry.question) {
    formulaEntry.question.isNew = true
    formulaEntry.question.id = getNewId("FORMULA_QUESTION")
  }

  if (formulaEntry.value) {
    formulaEntry.value.isNew = true
    formulaEntry.value.id = getNewId("FORMULA_VALUE")
  }

  if (formulaEntry.group) {
    formulaEntry.group.isNew = true
    formulaEntry.group.id = getNewId("FORMULA_GROUP")
    formulaEntry.group.formulas = formulaEntry.group.formulas.map(
      (formulaInGroup) => markFormulaEntryAsNew(formulaInGroup)
    )
  }

  if (formulaEntry.function) {
    formulaEntry.function.isNew = true
    formulaEntry.function.id = getNewId("FORMULA_FUNCTION")
    formulaEntry.function.values = formulaEntry.function.values.map(
      (functionValue) => markFormulaEntryAsNew(functionValue)
    )
  }

  if (formulaEntry.option) {
    formulaEntry.option.isNew = true
    formulaEntry.option.id = getNewId("FORMULA_OPTION")
  }

  return formulaEntry
}

function markFormulaEntryAsDeleted(formulaEntry) {
  formulaEntry.isDeleted = true

  if (formulaEntry.question) {
    formulaEntry.question.isDeleted = true
  }

  if (formulaEntry.value) {
    formulaEntry.value.isDeleted = true
  }

  if (formulaEntry.group) {
    formulaEntry.group.isDeleted = true
    formulaEntry.group.formulas = formulaEntry.group.formulas.map(
      (formulaInGroup) => markFormulaEntryAsDeleted(formulaInGroup)
    )
  }

  if (formulaEntry.function) {
    formulaEntry.function.isDeleted = true
    formulaEntry.function.values = formulaEntry.function.values.map(
      (functionValue) => markFormulaEntryAsDeleted(functionValue)
    )
  }

  if (formulaEntry.option) {
    formulaEntry.option.isDeleted = true
  }

  return formulaEntry
}
